/* Government-portal record shapes. Sparse for the same reason as the shared
 * types: RTDB rows predate several of these fields. */

export interface Inspection {
  id?: string
  inspection_date?: string
  date?: string
  outcome?: string
  findings?: string
  recommendations?: string
  follow_up_date?: string
  org_id?: string
  site_id?: string
  region_id?: string
  district_id?: string
  inspector_uid?: string
  status?: string
}

export interface MiningSite {
  id?: string
  name?: string
  org_id?: string
  region_id?: string
  district_id?: string
  mineral_type?: string
  status?: string
  validation_status?: string
  validation_notes?: string
  latitude?: number | string
  longitude?: number | string
  registered_at?: string
}

export interface GovLicence {
  id?: string
  license_number?: string
  org_id?: string
  status?: string
  mineral_type?: string
  issue_date?: string
  expiry_date?: string
  region_id?: string
  district_id?: string
}

/* Must match compliance_service.NOTICE_STATUSES / license_service.
 * update_license_status()'s real whitelist exactly - these two sets used to
 * drift from the backend (a security-audit fix tightened the API routes to
 * the service layer's actual values), so update both sides together if
 * either ever changes. */
export const NOTICE_STATUSES = ['issued', 'acknowledged', 'resolved', 'escalated'] as const
export const SITE_DECISIONS = ['validated', 'flagged', 'rejected'] as const
export const LICENCE_STATUSES = ['active', 'suspended', 'expired', 'cancelled'] as const
export const INSPECTION_OUTCOMES = ['compliant', 'minor_issues', 'major_issues', 'non_compliant'] as const
/* Must match compliance_service.NOTICE_TYPES' keys exactly, in the same
 * escalation order (compliance_service.NOTICE_ESCALATION only knows how to
 * escalate warning -> notice_to_comply -> suspension_notice -> closure_order;
 * a notice created with any other value could never be escalated past its
 * first tier). */
export const NOTICE_TYPES = ['warning', 'notice_to_comply', 'suspension_notice', 'closure_order'] as const
